
export const COMBO = 'DROP_DOWN';
export const DND = 'DRAG_AND_DROP';
export const MULTI = 'MULTI_CHOICE';
export const SINGLE = 'SINGLE_CHOICE';
export const FILL = 'FILL_BLANKS';

export const TYPE2COMPONENT = {
	[COMBO]: 'QuestionDropDown',
	[DND]: 'QuestionDragAndDrop',
	[MULTI]: 'QuestionMultiChoice',
	[SINGLE]: 'QuestionSingleChoice',
	[FILL]: 'QuestionFillBlanks',
}
